import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Check, ChevronDown, Loader2, SlidersHorizontal, X } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import MultiSelectFilter, {
  CONTENT_CLASS,
  FilterTrigger,
  ITEM_CLASS,
  ITEM_INDICATOR_CLASS,
  TRIGGER_CLASS,
} from './CRMFilterDropdown';

function SortFilter({ label, sortMode, sortOptions, onSortChange }) {
  const currentLabel = sortOptions.find((option) => option.value === sortMode)?.label || '';

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className={TRIGGER_CLASS}>
        <FilterTrigger label={label} selectedCount={0} activeLabel={currentLabel} />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={CONTENT_CLASS}
          side="bottom"
          sideOffset={6}
          align="start"
          collisionPadding={12}
        >
          <DropdownMenu.RadioGroup value={sortMode} onValueChange={onSortChange}>
            {sortOptions.map((option) => (
              <DropdownMenu.RadioItem
                key={option.value}
                value={option.value}
                className={cn(ITEM_CLASS, 'pl-8')}
              >
                <DropdownMenu.ItemIndicator className={ITEM_INDICATOR_CLASS}>
                  <Check className="h-4 w-4" />
                </DropdownMenu.ItemIndicator>
                <span className="flex-1 truncate">{option.label}</span>
              </DropdownMenu.RadioItem>
            ))}
          </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

const CRMBoardViewToolbar = ({
  filters,
  sortMode,
  options,
  visibleCount,
  totalCount,
  onToggleFilter,
  onSortChange,
  onReset,
  hasActiveView,
  isLoadingRecentActivity,
  t,
}) => {
  const sortOptions = [
    { value: 'manual', label: t('app:crm.t59') },
    { value: 'valueDesc', label: t('app:crm.t60') },
    { value: 'valueAsc', label: t('app:crm.t61') },
    { value: 'recentActivity', label: t('app:crm.t62') },
  ];

  return (
    <div className="mt-4">
      <div className="flex flex-wrap items-center gap-2 rounded-xl border border-stone-200 bg-white px-3 py-2 shadow-sm">
        <div className="mr-auto flex min-w-[220px] items-center gap-2 text-xs text-stone-500">
          <SlidersHorizontal className="h-4 w-4 text-stone-400" />
          <span>{t('app:crm.t53', { visible: visibleCount, total: totalCount })}</span>
          {isLoadingRecentActivity ? (
            <span className="inline-flex items-center gap-1 text-stone-400">
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
              {t('app:crm.t64')}
            </span>
          ) : null}
        </div>

        <MultiSelectFilter
          label={t('app:crm.t54')}
          selectedValues={filters.countries}
          options={options.countries}
          showCountryFlags
          onToggle={(value) => onToggleFilter('countries', value)}
          emptyLabel={t('app:crm.t65')}
        />

        <MultiSelectFilter
          label={t('app:crm.t55')}
          selectedValues={filters.types}
          options={options.types}
          onToggle={(value) => onToggleFilter('types', value)}
          emptyLabel={t('app:crm.t65')}
        />

        <MultiSelectFilter
          label={t('app:crm.t56')}
          selectedValues={filters.industries}
          options={options.industries}
          onToggle={(value) => onToggleFilter('industries', value)}
          emptyLabel={t('app:crm.t65')}
        />

        <SortFilter
          label={t('app:crm.t57')}
          sortMode={sortMode}
          sortOptions={sortOptions}
          onSortChange={onSortChange}
        />

        {hasActiveView ? (
          <Button
            variant="ghost"
            size="sm"
            iconLeft={<X className="h-3.5 w-3.5" />}
            onClick={onReset}
            className="rounded-full px-3 text-xs text-stone-600 hover:text-stone-900"
          >
            {t('app:crm.t58')}
          </Button>
        ) : null}
      </div>

      {hasActiveView ? (
        <p className="mt-2 text-xs text-stone-500">
          {t('app:crm.t63')}
        </p>
      ) : null}
    </div>
  );
};

export default CRMBoardViewToolbar;
